import { NextSeo } from 'next-seo';

//screens
import { DockScheduleManagement } from '@/screens/Agents/DockScheduleManagement';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function DockScheduleManagementPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/dock-schedule-management/"
        title="Dock Schedule Management Agent | Loadsmart AI"
        description="Keeps the Opendock dock schedule on plan: a briefing before the first shift, late arrivals moved to the next valid slot, and a reschedule plan ready when dock capacity drops. It acts where your configured Opendock rules stop."
        openGraph={{
          url: 'https://loadsmart.com/ai/dock-schedule-management/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/ai/dock-schedule-management.png`,
              width: 1200,
              height: 630,
              alt: 'Dock Schedule Management Agent',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <DockScheduleManagement />
    </>
  );
}
